export default "__VITE_ASSET__9H1$TS4M__"